import { AuthStatus } from '@amzn/bf-playback'
import { getAuth } from '@/auth/authRef'

/**
 * Resolves once auth leaves the cold-start PENDING window (SIGNED_IN or
 * SIGNED_OUT). A caller that snapshots `isSignedIn()` at query time must wait
 * this out, else a query fired mid-warmup reads a false sign-in state. Resolves
 * immediately when auth has already settled.
 */
export function awaitAuthSettled(): Promise<void> {
    const status = getAuth().status
    if (status.value !== AuthStatus.PENDING) return Promise.resolve()
    return new Promise((resolve) => {
        const settledSub = status.onData((value) => {
            if (value === AuthStatus.PENDING) return
            settledSub()
            resolve()
        })
    })
}
